export default {
  edit: {
    title: 'edit',
    type: 'object',
    properties: {
      name: {
        type: 'string',
        minLength: 1,
      },
      permissions: {
        type: 'array',
      },
    },
    required: ['name', 'permissions'],
  },
};



// WEBPACK FOOTER //
// src/lib/schemas/roles_schemas.js